








































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import AccountHelpers, { Account } from "@/models/account";
import AccountSearchHelpers, { AccountSearch } from "@/models/accountsearch";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { save } from "@/helpers/storage";
import { Order } from "@/models/order";
import Address from "../Address.vue";
const log = NSLog("view/PlaceUserOrder");

@Component({
  components: {
    loader
  }
})
export default class AccountComponent extends Vue {
  // selected account helpers account
  private get accountID() {
    return this.hxAccount ? this.hxAccount.id : null;
  }
  private get accountDisplayText() {
    return this.accountID
      ? AccountHelpers.DisplayText(this.hxAccount)
      : this.accountSearchStr;
  }
  @Mutation("setLastErr") public setLastErr: any;

  @Prop() public value?: Account;
  private loading = false;

  private tabIdx = 0;

  private hxAccount?: Account = AccountHelpers.New();

  private foundAccounts: any = [];
  private newValid = false;
  private newAccount?: Account = AccountHelpers.New();
  private newLoading = false;

  private updateModified = false;
  private updateLoading = false;

  // ============================================== \\
  // =========== search billing account =========== \\
  // ============================================== \\
  private accountSearchStr = "";
  public created() {
    if (this.value) {
      this.hxAccount = this.value;
      this.tabIdx = 2;
    }
  }
  @Watch("accountSearchStr") public watchAccountSearchStr(v: string) {
    this.searchAccounts(v);
  }

  // ============================================== \\
  // ========= set / updatebilling account ======== \\
  // ============================================== \\
  private async setAccount(acc?: Account) {
    if (!acc) {
      this.hxAccount = AccountHelpers.New();
      this.updateModified = false;
      this.$emit("input", this.hxAccount);
    } else if (!this.hxAccount || this.hxAccount.id !== acc.id) {
      this.hxAccount = acc;
      this.$emit("input", this.hxAccount);
      this.tabIdx = 2;
    }
  }
  private async searchAccounts(str?: string) {
    if (str === undefined) {
      this.foundAccounts = [];
    }
    if (!str || str.length < 3) {
      return;
    }
    this.loading = true;
    this.searchAccountsDebounce(str);
  }
  private clearSearch() {
    this.setAccount();
    this.searchAccounts();
  }
  // debounced search account
  @debounce(500, { leading: false })
  private async searchAccountsDebounce(str: string) {
    this.setLastErr();
    this.loading = true;
    try {
      this.foundAccounts = await accountsApi.searchAccounts(str);
    } catch (e) {
      this.setLastErr(e);
    }
    this.loading = false;
  }

  private async createAccountAndSelect() {
    this.setLastErr();
    this.newLoading = true;
    if (!this.newAccount) {
      return;
    }
    try {
      const newAccount = await accountsApi.RegisterAccount(this.newAccount);
      this.hxAccount = newAccount;
      this.tabIdx = 2;
      this.newAccount = AccountHelpers.New();
      this.$emit("next", this.hxAccount);
    } catch (e) {
      this.setLastErr(e);
    }
    this.newLoading = false;
  }

  private async updateAccountAndContinue() {
    this.setLastErr();
    this.updateLoading = true;
    if (!this.hxAccount) {
      return;
    }

    try {
      const newAccount = await accountsApi.UpdateAccount(this.hxAccount);
      this.hxAccount = newAccount;

      this.$emit("next", this.hxAccount);
    } catch (e) {
      this.setLastErr(e);
    }
    this.updateLoading = false;
    this.updateModified = false;
  }

  private async selectAccountAndContinue() {
    this.$emit("next", this.hxAccount);
  }

  private destroyed() {
    cancel(this.searchAccountsDebounce);
  }
}
